import { ModalNextProvider } from '@jutro/components';
import { messages } from './alertHelper.messages';
export function showAlert(message, title, callback = () => {}) {
  const useDefault = false;
  if (useDefault || false) {
    dom.window.alert(message);
    return;
  }
  const icon = 'mi-error-outline';
  const status = 'warning';
  const noop = () => {};
  const answer = ModalNextProvider.showAlert({
    title: title || messages.actionWarning,
    message,
    status,
    icon,
    confirmButtonText: messages.ok
  });
  answer.then(callback, noop);
}